export const AbsenceType = Object.freeze({
  sick: 'sick',
})

export const AbsenceStatus = Object.freeze({
  approved: 'approved',
  canceled: 'canceled',
})
